/* eslint-disable multiline-ternary */
/* eslint-disable indent */
import findIndex from 'lodash/findIndex';
import isEmpty from 'lodash/isEmpty';
import { GetServerSideProps, NextPage } from 'next';
import { NextSeo } from 'next-seo';
import dynamic from 'next/dynamic';
import Head from 'next/head';
import { useState } from 'react';
import { APP_URL } from 'src/constants';
import { decryptionClient } from 'src/services/member-auth/utils/decryption-payload';
import { timestamp } from 'src/utils/helper';
import { GET } from 'src/utils/service';
import useUser from 'src/utils/useUser';
import styled from 'styled-components';

const PageError = dynamic(import('pages/404'));
const Layout = dynamic(import('src/components/layouts'));

interface IProps {
  navBar?: any;
  privacyDataArray?: any;
}

const PrivacyPolicyPage: NextPage<IProps> = ({ privacyDataArray, navBar }) => {
  const _data = useUser();
  const sessionSevId = _data?.user ? decryptionClient(_data?.user) : null;
  const [checkedState, setCheckedState]: any[] = useState([true, false, false]);
  const arrayName = ['นโยบายการใช้คุกกี้', 'ข้อกำหนดและเงื่อนไข', 'คำประกาศเกี่ยวกับความเป็นส่วนตัว'];
  function handleOnChange(position: any) {
    const newUpdate = [false, false, false];
    newUpdate[position] = true;
    setCheckedState(newUpdate);
  }
  const activeTabIndex = findIndex(checkedState, e => e === true);

  if (isEmpty(privacyDataArray[0]) || isEmpty(privacyDataArray[1]) || isEmpty(privacyDataArray[2])) return <PageError sessionSevId={sessionSevId} navBar={navBar} />;
  // <div dangerouslySetInnerHTML={{ __html: privacyDataArray[index] }} /> // index is a policy no. //still in section tag
  return (
    <>
      <NextSeo noindex={true} nofollow={true} title='นโยบายการเป็นส่วนตัว' />
      <Head>
        <link rel='canonical' href={`${APP_URL}/privacy-policy`} />
        {/* --------------------------------- Truehit -------------------------------- */}
        <script
          type='text/javascript'
          dangerouslySetInnerHTML={{
            __html: `
                __th_page="privacy-policy";
              `
          }}
        />
      </Head>
      <Layout sessionSevId={sessionSevId} data={{ header: navBar, footer: navBar }}>
        <div className='container'>
          {!isEmpty(privacyDataArray[0]) &&
            privacyDataArray[0].data !== null &&
            !isEmpty(privacyDataArray[1]) &&
            privacyDataArray[1].data !== null &&
            !isEmpty(privacyDataArray[2]) &&
            privacyDataArray[2].data !== null ? (
            <SectionWrapper seq={activeTabIndex} themeColor={'#ed1a3b'}>
              <div className='tab-link'>
                <div className='tab-button'>
                  {arrayName.map((item, index) => (
                    <li key={index}>
                      <label>
                        <input name='tab-control' onChange={() => handleOnChange(index)} type='checkbox' value={checkedState[index]} checked={checkedState[index] && true}></input>
                        <span>{`${item}`}</span>
                      </label>
                    </li>
                  ))}
                </div>
                <div className='indicator'></div>
              </div>
              <div className='content-container'>
                <div className={`policy ${activeTabIndex === 0 ? 'open-0' : ''}`} dangerouslySetInnerHTML={{ __html: privacyDataArray[0] }} />
                <div className={`policy ${activeTabIndex === 1 ? 'open-1' : ''}`} dangerouslySetInnerHTML={{ __html: privacyDataArray[1] }} />
                <div className={`policy ${activeTabIndex === 2 ? 'open-2' : ''}`} dangerouslySetInnerHTML={{ __html: privacyDataArray[2] }} />
              </div>
            </SectionWrapper>
          ) : (
            'ยังไม่ได้กำหนด privacy-policy'
          )}
        </div>
      </Layout>
    </>
  );
};
const SectionWrapper: any = styled.div<{
  themeColor: string | any;
  seq: string | any;
}>`
  padding: 0.75rem 0;
  .tab-link {
    padding-bottom: 10px;
    padding-left: 10px;
    padding-right: 10px;
  }
  .tab-button {
    display: flex;
    flex-direction: row;
    margin-bottom: 10px;
    justify-content: space-between;
    align-items: flex-end;
    flex-wrap: wrap;
    list-style-type: none;
    height: 50px;
    width: 100%;
    align-items: center;
    border-bottom: 4px solid #e3dede;
    @media (max-width: 475px) {
      padding-bottom: 70px;
    }
    li {
      box-sizing: border-box;
      flex: 1;
      width: 25%;
      padding: 0 10px;
      text-align: center;
      display: list-item;
      input:checked + span {
        color: ${props => props.themeColor};
      }
      label {
        white-space: initial;
        color: silver;
        overflow: hidden;
        text-overflow: ellipsis;
        display: block;
        cursor: pointer;
        transition: all 0.5s ease-in-out;
        font-weight: bold;
        font-size: 16px;
        width: 100%;
        @media (max-width: 992px) {
          font-size: 14px;
        }
        @media (max-width: 475px) {
          font-size: 14px;
        }
        @media (max-width: 350px) {
          font-size: 12px;
        }
        &:hover {
          color: #585858;
        }
        input {
          display: none;
          transition: all 0.5s ease-in-out;
        }
      }
    }
  }

  .indicator {
    position: relative;
    width: calc(100% / 3);
    left: calc(calc(100% / 3) * ${props => props.seq});
    max-width: 100%;
    transition: all 0.33s ease-in-out;
    height: 4px;
    background: ${props => props.themeColor};
    border-radius: 1px;
    margin-top: -22px;
    top: 8px;
  }

  .content-container {
    display: block;
    position: relative;
    margin: 30px 0;
    overflow-y: auto;
    height: auto;
    min-height: 620px;
    &::-webkit-scrollbar {
      width: 6px;
      background-color: #e3dede;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-track {
      background-color: #ffffff21;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background-color: ${props => props.themeColor};
    }
    @media (max-width: 992px) {
      min-height: 700px;
    }
    @media (max-width: 475px) {
      min-height: 350px;
    }
    @media (max-width: 280px) {
      min-height: 370px;
    }
    .policy {
      position: absolute;
      top: 0;
      left: -250%;
      width: 100%;
      opacity: 0;
      overflow: hidden;
      transition: all 1.5s ease-in-out;
      &.open-0 {
        left: 0;
        opacity: 1;
        width: 100%;
      }
      &.open-1 {
        left: 0;
        opacity: 1;
        width: 100%;
      }
      &.open-2 {
        left: 0;
        opacity: 1;
        width: 100%;
      }
    }
  }
`;

export const getServerSideProps: GetServerSideProps = async ({ req, res }: any) => {
  const initProps: any = {
    statusCode: 200,
    errMessage: null,
    privacyDataArray: [],
    navBar: []
  };
  async function getPolicyData() {
    const resDataI = GET('/api/privacy-policy?policy=1');
    const resDataII = GET('/api/privacy-policy?policy=2');
    const resDataIII = GET('/api/privacy-policy?policy=3');
    const res = await Promise.all([resDataI, resDataII, resDataIII]);
    try {
      const result = await res;
      return [result[0], result[1], result[2]];
    } catch (err: any) {
      console.error(`${timestamp()} ==========> PRIVACY ERROR : `, err.message);
      initProps.errMessage = err.message;
      initProps.statusCode = err?.response?.status || 500;
    }
  }

  try {
    const fetchMenuNav = await GET('/api/v1.0/navigations/menu-nav?limit=6');
    const privacyDataArray: any = await getPolicyData();
    if (!isEmpty(privacyDataArray)) initProps.privacyDataArray = privacyDataArray || [];
    if (!isEmpty(fetchMenuNav)) initProps.navBar = fetchMenuNav;
  } catch (err: any) {
    console.error(`${timestamp()} ==========> PRIVACY_POLICY ERROR : `, err.message);
    initProps.errMessage = err.message;
    initProps.statusCode = err?.response?.status || 500;
  }

  return {
    props: initProps
  };
};

export default PrivacyPolicyPage;
